import * as React from 'react';

const ProgressListGrammarContext = React.createContext<any>(null);

export const withProgressListGrammar = (Component: any) => (props: any) => {
  const [initialed, setInitialed] = React.useState(false);
  const [userAnswers, setUserAnswers] = React.useState([]);
  const [isShowResult, setIsShowResult] = React.useState(false);
  const [isOpenDrawer, setIsOpenDrawer] = React.useState(false);
  const [currentBlankId, setCurrentBlankId] = React.useState('');

  const initProgress = (progress) => {
    setUserAnswers(progress?.userAnswers);
    setInitialed(true);
  };

  const storeValue = {
    initialed,
    initProgress,
    userAnswers,
    setUserAnswers,
    isShowResult,
    setIsShowResult,
    isOpenDrawer,
    setIsOpenDrawer,
    currentBlankId,
    setCurrentBlankId,
  };
  return (
    <ProgressListGrammarContext.Provider value={storeValue}>
      <Component {...props} />
    </ProgressListGrammarContext.Provider>
  );
};

export const useProgressListGrammar = () => React.useContext(ProgressListGrammarContext);
